import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CERTIFICA_CELLULARE,
  CERTIFICA_CELLULARE_FAIL,
  CERTIFICA_CELLULARE_SUCCESS,
  CERTIFICA_CELLULARE_OTP,
  CERTIFICA_CELLULARE_OTP_SUCCESS,
  CERTIFICA_CELLULARE_OTP_FAIL,
} from './certifica-cellulare.actions';
import { mergeMap, catchError, of } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { IResponseCertificaEmail } from '../../interfaces/certifica-email';
import { Store } from '@ngrx/store';
import { ADD_MESSAGE } from '../messages/messages.actions';

@Injectable()
export class CertificaCellulareEffects {

  submitCellulare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CERTIFICA_CELLULARE),
      mergeMap(({ cellulare }) =>
        this.api.certificaCellulare({ cellulare }).pipe(
          mergeMap((response: IResponseCertificaEmail) => [
            CERTIFICA_CELLULARE_SUCCESS({
              esito: response.esito,
              seed: response.seed!,
              cellulare,
              otpTtlSeconds: response.otpTtlSeconds,
              msgCode: response.msgCode,
              maxTentativi: response.maxTentativi,
            })
          ]),
          catchError((error) => {
            this.store.dispatch(ADD_MESSAGE({ message: error?.message || 'Errore invio SMS OTP' }));
            return of(CERTIFICA_CELLULARE_FAIL({ error }));
          })
        )
      )
    )
  );

  submitOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CERTIFICA_CELLULARE_OTP),
      mergeMap(({ otp, seed, username, cellulare }) =>
        this.api.verificaOtp({
          otp,
          seed,
          username,
          telefono_certificato: cellulare,
        }).pipe(
          mergeMap((response) => [
            CERTIFICA_CELLULARE_OTP_SUCCESS({
              esito: response.esito,
              msgCode: response.msgCode,
              username: response.username,
            })
          ]),
          catchError((error) => {
            this.store.dispatch(ADD_MESSAGE({ message: error?.message ?? 'Errore verifica OTP' }));
            return of(CERTIFICA_CELLULARE_OTP_FAIL({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store,
  ) {}
}
